import type { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';

import FAQCategoriesWithFAQs from '@components/common/FAQCategoriesWithFAQs/FAQCategoriesWithFAQs';
import OtherCarsNearYouSection from '@components/common/OtherCarsNearYouSection/OtherCarsNearYouSection';
import SectionWithContainer from '@components/common/SectionWithContainer/SectionWithContainer';
import { FaqCategory } from 'models/FaqCategory';

import carService from 'services/carService';
import faqService from 'services/faqService';

export const getServerSideProps: GetServerSideProps = async () => {
  try {
    const [faqCategories, featuredCars] = await Promise.all([
      faqService.getAllCategoriesWithFAQsBySlug('faqs'),
      carService.getFeaturedCars(),
    ]);
    return { props: { faqCategories, featuredCars } };
  } catch (error) {
    console.error('error', error);
    return { props: { statusCode: 500 } };
  }
};

const FAQs: NextPage<{ faqCategories: FaqCategory[]; featuredCars: any }> = ({
  faqCategories,
}) => {
  return (
    <>
      <NextSeo
        title="FAQs"
        description="Visit the Simplr help center to read FAQs, send questions, or connect with our team. You’ll get answers to everything you need to subscribe your next car."
      />
      <SectionWithContainer withPadding={false} className="py-6">
        <h1 className="mb-4 text-3xl font-light text-center text-dark-blue-100 md:text-4xl">
          Frequently Asked Questions
        </h1>
      </SectionWithContainer>
      <SectionWithContainer className="border-t-4 border-t-coral-100">
        <FAQCategoriesWithFAQs faqCategories={faqCategories} />
      </SectionWithContainer>
      <OtherCarsNearYouSection />
    </>
  );
};

export default FAQs;
